import { SeoLandingLayout, SeoLandingPageData } from '../../../components/SeoLandingLayout';

const data: SeoLandingPageData = {
  seo: {
    title: 'Trésorerie saisonnière restaurant : gérer les hauts et les bas | Trezoone',
    description: 'La restauration a une trésorerie cyclique. Comment gérer les basses saisons, constituer une réserve et anticiper les creux avec un plan de trésorerie adapté.',
    canonical: '/tresorerie-saisonniere-restaurant',
    keywords: 'trésorerie restaurant, trésorerie saisonnière, gestion cash restaurant, trésorerie hôtel restaurant',
  },
  hero: {
    tag: 'Trésorerie restaurant',
    title: 'En janvier, votre restaurant est vide. En août, il est plein. Votre trésorerie doit survivre aux deux.',
    subtitle: 'La saisonnalité est une réalité pour la restauration. Voici comment la gérer pour ne jamais être à court de cash en basse saison.',
    ctaLabel: 'Simuler ma saisonnalité',
    ctaHref: '/simulateur-tresorerie-association',
  },
  pilierLink: { label: 'Gestion de trésorerie TPE', href: '/gestion-tresorerie-tpe' },
  sections: [
    {
      type: 'explain',
      title: 'Les défis spécifiques de la trésorerie en restauration',
      content: 'La restauration a des particularités financières qui rendent la gestion de trésorerie complexe :',
      items: [
        'Encaissements quotidiens immédiats (contrairement à la facturation B2B)',
        'Charges fixes importantes et incompressibles (loyer, personnel)',
        'Saisonnalité forte selon le type d\'établissement',
        'TVA à reverser sur des encaissements que vous avez déjà dépensés',
        'Coûts alimentaires variables selon les prix matières',
      ],
    },
    {
      type: 'example',
      title: 'Exemple : restaurant balnéaire, plan de trésorerie annuel',
      content: 'Ouvert d\'avril à septembre. Chiffre d\'affaires concentré sur juillet-août.',
      items: [
        'Juillet-Août : CA 60 000 €/mois → constitution de réserve obligatoire',
        'Septembre-Mars : charges fixes 8 000 €/mois, CA quasi nul',
        'Réserve nécessaire : 7 mois × 8 000 € = 56 000 € minimum',
        'Sans plan : réserve insuffisante → découvert en hiver → agios → stress',
        'Avec plan : calcul exact de la réserve nécessaire dès le début de la haute saison',
      ],
    },
    {
      type: 'midcta',
      title: '56 000 € de réserve à constituer en haute saison — calculez le chiffre exact pour votre restaurant',
      content: 'Trezoone modélise votre saisonnalité et calcule précisément la réserve à constituer pour survivre à votre prochaine basse saison.',
    },
    {
      type: 'solution',
      title: 'Trezoone adapté à la saisonnalité de votre établissement',
      content: 'Modélisez votre saisonnalité une fois et laissez Trezoone calculer votre besoin de réserve.',
      items: [
        'Plan de trésorerie sur 12 mois intégrant la saisonnalité',
        'Calcul automatique de la réserve à constituer en haute saison',
        'Alerte quand la réserve est insuffisante',
        'Simulation de l\'impact d\'une mauvaise saison sur votre trésorerie',
        'Suivi mensuel simplifié pour les restaurateurs',
      ],
    },
    {
      type: 'cluster',
      title: 'Ressources pour les TPE à activité saisonnière',
      links: [
        { label: 'Gestion trésorerie TPE', href: '/gestion-tresorerie-tpe' },
        { label: 'Plan de trésorerie', href: '/plan-tresorerie' },
        { label: 'Prévision trésorerie', href: '/prevision-tresorerie' },
        { label: 'Manque de trésorerie', href: '/manque-tresorerie' },
        { label: 'Alerte trésorerie', href: '/alerte-tresorerie' },
        { label: 'Stress test trésorerie', href: '/stress-test-tresorerie' },
        { label: 'Simulateur trésorerie', href: '/simulateur-tresorerie-association' },
        { label: 'Modèle plan trésorerie', href: '/modele-plan-tresorerie' },
      ],
    },
    {
      type: 'cta',
      title: 'Préparez votre prochaine basse saison dès maintenant',
      content: 'Trezoone vous aide à calculer la réserve nécessaire. Essai gratuit 14 jours.',
    },
  ],
  relatedLinks: [
    { label: 'Gestion trésorerie TPE', href: '/gestion-tresorerie-tpe' },
    { label: 'Plan de trésorerie', href: '/plan-tresorerie' },
    { label: 'Prévision trésorerie', href: '/prevision-tresorerie' },
    { label: 'Manque de trésorerie', href: '/manque-tresorerie' },
    { label: 'Alerte trésorerie', href: '/alerte-tresorerie' },
    { label: 'Stress test trésorerie', href: '/stress-test-tresorerie' },
    { label: 'Simulateur trésorerie', href: '/simulateur-tresorerie-association' },
    { label: 'Cash flow entreprise', href: '/cash-flow-entreprise' },
  ],
};

interface Props { onNavigate?: (p: string) => void; onSignIn?: () => void; onSignUp?: () => void; }
export default function TresorerieSaisonniereRestaurantPage({ onNavigate, onSignIn, onSignUp }: Props) {
  return <SeoLandingLayout data={data} onNavigate={onNavigate} onSignIn={onSignIn} onSignUp={onSignUp} />;
}
